import { setDefaults as a } from "./index90.mjs";
var i = {
  type: "3rdParty",
  init: function(t) {
    a(t.options.react);
  }
};
export {
  i as initReactI18next
};
